import api from './axios';

// Service-worker (provider) registration against the EXISTING backend API.
// Backend contract (read-only — see Tasmeh-backend/src/services/mechanic.service.js):
//   POST /mechanics/register (auth required)
//   required body: { firstName, lastName, workPhone, field }
//   optional body: { landline, address }
//   field is the MechanicField enum: SERVICE_WORKER | MECHANIC | BODY_WORKER
//
// NOTE: the backend Mechanic model has no dedicated "shop/collection name"
// column, so a `shopName` value sent alongside is ignored server-side today
// (the service destructures only the keys above). It is still forwarded for
// forward-compatibility and documented on the registration page.
export const MECHANIC_FIELD_SERVICE_WORKER = 'SERVICE_WORKER';
export const MECHANIC_FIELD_MECHANIC = 'MECHANIC';
export const MECHANIC_FIELD_BODY_WORKER = 'BODY_WORKER';

// Exact option list for the "حوزه کاری" (work area) selector on the
// mechanic registration page. Values are the existing backend
// `MechanicField` enum members verbatim (Tasmeh-backend/prisma/schema.prisma)
// — the `field` body key of POST /mechanics/register accepts only these.
// Labels are display-only Persian text; values are submitted unchanged.
export const MECHANIC_FIELD_OPTIONS = [
  { value: MECHANIC_FIELD_SERVICE_WORKER, label: 'سرویس‌کار' },
  { value: MECHANIC_FIELD_MECHANIC, label: 'مکانیک' },
  { value: MECHANIC_FIELD_BODY_WORKER, label: 'صافکار' },
];

export const registerMechanic = async (mechanicData) => {
  const response = await api.post('/mechanics/register', mechanicData);
  return response.data;
};

export const getMyMechanicProfile = async () => {
  const response = await api.get('/mechanics/me');
  return response.data;
};

// Service-worker (provider) deletion against the EXISTING backend API.
// Backend contract (read-only — see Tasmeh-backend/src/services/mechanic.service.js):
//   DELETE /mechanics/me (auth required) → permanently removes the caller's
//   mechanic profile. Afterwards GET /mechanics/me returns 404, so
//   the UserPanel falls back to the "Register as Service Worker" entry point.
//   The main user account and auth token are untouched — only the mechanic
//   profile is deleted. The same user can then register a fresh profile.
export const deleteMyMechanicProfile = async () => {
  const response = await api.delete('/mechanics/me');
  return response.data;
};
